<script lang="ts" setup>
import StorageService from '../../../runtime/services/StorageService';

const { $log } = useLogging();
const { $alert } = useAlerts();
const { $t } = useLocalization();

const props = defineProps<{
    id: number;
}>();

const model = defineModel<Record<string, string>>({});
const modalRef = ref<any>(null);

const loading = ref(false);

const saveMeta = async (): Promise<void> =>
{
    try
    {
        loading.value = true;

        await StorageService.updateMeta(props.id, model.value);

        $alert.success($t('[[[Zmiany zostały zapisane.]]]'));
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
    finally
    {
        loading.value = false;
    }
};

const showModal = (items: FileResource[]): void =>
{
    modalRef.value.show();
};

defineExpose({
    showModal
});
</script>

<template>
    <IdeoModal
        ref="modalRef"
        :title="$t('[[[Aktualizacja danych exif]]]')"
        hide-footer
        size="xl"
        modal-class="filemanager-modal"
        backdrop-class="filemanager-backdrop"
    >
        <div class="row">
            <div v-for="key in Object.keys(model).filter(k => k !== 'width' && k !== 'height')" :key="key" class="col-md-4">
                <IdeoFormGroup :label="key">
                    <IdeoFormInput v-model="model[key]" type="text" />
                </IdeoFormGroup>
            </div>
        </div>

        <div class="text-end">
            <ActionButton
                variant="light"
                icon="far fa-ban"
                :text="$t('[[[Zamknij]]]')"
                @click.prevent="modalRef.hide()"
            />
            <ActionButton
                variant="primary"
                icon="far fa-check"
                :loading="loading"
                :text="$t('[[[Zapisz]]]')"
                @click.prevent="saveMeta()"
            />
        </div>
    </IdeoModal>
</template>
